// @ commons
import { FormattedText, formatText } from 'core/i18n';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { stopPolling } from 'actions/polling';
import { isMobile } from 'utilities/browser';
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';
import { JointHolderAdviseModal } from 'components/newAccountSteps/profileSteps/jointHolderAdviseModal/jointHolderAdviseModal';
import { history } from 'routes/history';
import {
    disableNationalityByCountry,
    getReferencePrefixByCountry,
    isCountrySpain,
} from 'utilities/multiLanguageHelper';
import { BASE_PATH } from 'constants';
import UtagHelper from 'utilities/utagHelper';
import { throttle } from 'utilities/helperFunctions';
import { ONBOARDING_FLAG_WEB_NEW_REGISTER } from 'constants/featureFlagging';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import consentsActions from 'actions/consentsActions';
import { createClientWithConsent } from 'components/newAccountSteps/profileSteps/services/createClientWithConsent';
import { InputPassport } from 'components/shared/InputPassport/InputPassport';
import { getEuropeanUnionContries } from 'utilities/getEuropeanUnionContries';

require('../profileSteps.scss');
require('sass/blocks/_joint-holders.scss');
require('sass/_OTPInput.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const { Form } = require('react-redux-form');
const cryptoJS = require('crypto-js');
// @ utilities
const {
    recordEvent,
    recordError,
    recordEventCustomOnly,
    recordCreateNewClient,
    PAGE_PRODUCT,
    errorTag,
    recordEventStepSuccess,
} = require('utilities/uTagging');
const { PATH_CONTACT } = require('constants/uTagConstants/paths');
const scroll = require('utilities/scroll');
const tools = require('utilities/tools');
const { clickTaleStart, clickTaleEnd } = require('utilities/clickTale');
const Storage = require('utilities/storage');
const addressHelper = require('utilities/addressHelper/addressHelper');

// @ components
const JointHolderDecisionDispatcher = require('components/jointHolders/jointHoldersDecisionDispatcher');
const Headline = require('components/headline');
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;
const { ProfileStep1Form } = require('components/newAccountSteps/profileSteps/profileStep1Form');
const JointHolder = require('components/additional/jointHolder').JointHolder;
const OtpView = require('components/additional/otpView').OtpView;
const { OpenCreditSale } = require('components/commons/openCreditSale/openCreditSale');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @ actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');
const optionsActions = require('actions/optionsActions');
const focusActions = require('actions/focusActions');
const ibanActions = require('actions/ibanActions');
const standByActions = require('actions/standByActions');
const createActions = require('actions/createActions');
const cmsActions = require('actions/cmsActions');
const preLoaderActions = require('actions/preLoaderActions');

// @ constants
const { FIXED_PAYMENT_METHOD_VALUE, VARIABLE_PAYMENT_METHOD_VALUE } = require('utilities/paymentMethodHelper');
const { ADDITIONAL_TEXT, ADDITIONAL_TOOLTIP } = require('constants/cms');
const {
    ERROR_AL_AGREGAR_INFORMACION_ADICIONAL,
    ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE,
} = require('constants/analyticsErrors');
const { TRADITIONAL, GBI, ROBO, CREDIT_CARD } = require('constants/userProfile');
const {
    getMainDocumentTypeByCountry,
    getReferenceCodeByCountry,
    getAliasesDocumentType,
} = require('utilities/multiLanguageHelper');
const {
    mustIncludeJoinDecision,
    mustIncludeJoinDecisionLikeRequiredField,
    mustValidatePostalCode,
    mustIncludeExtraAddressFields,
    getValidationPostalCodeByCountry,
    showPassportProfile1,
} = require('utilities/logicByCountry');
const {
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_DOCUMENT_TYPE_DNI,
} = require('constants/multiLanguage');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes');

const modalCancelActions = require('actions/modalCancelActions');

const ERROR_TYPE_CLIENT_IS_BLOCKED = '10001';
const ERROR_TYPE_CLIENT_ACCOUNT_NOT_IN_HOLDING = '6002';
const ERROR_TYPE_POSTALCODE_NOT_MATCH_PROVINCE = '0243';
const ERROR_TYPE_POSTALCODE_NOT_VALID = '0242';

class ProfileStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVerified: false,
            showPassport: false,
            isClicked: true,
            checkbox: false,
        };

        this.handleToggleAddress = this.handleToggleAddress.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeDepositWarning = this.closeDepositWarning.bind(this);
        this.onHandleValidateFields = this.onHandleValidateFields.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.formValidations = {
            primaries: [
                'gender',
                'nationality',
                'birthCountry',
                'birthPopulation',
                'cellPhone',
                'cellPhoneConfirmation',
            ],
            firstAddress: ['nameOfRoad', 'addressNumber', 'postalCode', 'town'],
            secondAddress: ['nameOfRoad2', 'addressNumber2', 'postalCode2'],
        };
        if (mustIncludeExtraAddressFields()) {
            this.formValidations = {
                primaries: [
                    'gender',
                    'nationality',
                    'cellPhone',
                    'birthCountry',
                    'birthPopulation',
                    'cellPhoneConfirmation',
                ],
                firstAddress: ['nameOfRoad', 'addressNumber', 'postalCode', 'typeOfRoad', 'town', 'province'],
                secondAddress: ['nameOfRoad2', 'addressNumber2', 'postalCode2', 'typeOfRoad2', 'province2'],
            };
        }

        this.handleShowPassport = this.handleShowPassport.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.buildPassport = this.buildPassport.bind(this);
        this.getAllData = this.getAllData.bind(this);
        this.getHomeAddress = this.getHomeAddress.bind(this);
        this.handleAddressUpdate = this.handleAddressUpdate.bind(this);
        this.bufferedSaveAddressInformation = tools
            .aggregatedDebounce(this.bufferedSaveAddressInformation, 1000)
            .bind(this);
        this.throttledGeoAddressScroll = throttle(this.throttledGeoAddressScroll, 100).bind(this);
        this.showJointHolderDecision = this.showJointHolderDecision.bind(this);
        this.gotoNextStep = this.gotoNextStep.bind(this);
        this.getProvinces = this.getProvinces.bind(this);
        this.createClient = this.createClient.bind(this);
        this.handleEnableSubmit = this.handleEnableSubmit.bind(this);
    }

    /*
     * Before Render, this method send request to API
     */
    UNSAFE_componentWillMount() {
        const { userProfile, options, optionsActions, formActions, flags } = this.props;

        if (options.get('countries').size === 0) {
            optionsActions.getProvinces();
            optionsActions.getCountries();
        }

        const shouldShowNationalityField = !flags.get(ONBOARDING_FLAG_WEB_NEW_REGISTER) || userProfile.isAlreadyClient;
        formActions.change('userProfile.shouldShowNationalityField', shouldShowNationalityField);

        if (disableNationalityByCountry(userProfile.documentType) && shouldShowNationalityField) {
            formActions.change('userProfile.nationality', getReferenceCodeByCountry().toUpperCase());
        }

        this.handleShowPassport(userProfile.nationality);
        this.setState({ checkbox: userProfile.creditCardOffer_accepted });
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { cmsActions, initialStep, preLoaderActions } = this.props;

        if (initialStep.get('fromInitialStep')) preLoaderActions.hidePreLoader();
        cmsActions.getCMS(ADDITIONAL_TEXT, ADDITIONAL_TOOLTIP);
        clickTaleStart();
    }

    componentDidUpdate(prevProps) {
        const { userProfileForm, userProfile } = this.props;

        if (prevProps.userProfileForm.$form.valid !== userProfileForm.$form.valid) {
            this.handleEnableSubmit();
        }

        if (!userProfileForm.$form.valid && this.props.focus.get('triggerValidations')) {
            const errosElements = document.getElementsByClassName('valid-error');
            if (errosElements.length > 0) {
                const input = errosElements[0].getElementsByTagName('input')[0];
                if (typeof input !== 'undefined') {
                    scroll.transition(input);
                    setTimeout(() => {
                        input.focus();
                    }, 250);
                } else {
                    this.props.focusActions.setFocusForm(errosElements[0].id);
                    const element = errosElements[0];
                    scroll.transition(element);
                }
            }

            this.props.focusActions.triggerValidations(false);
        }
        if (this.props.options.get('countries') !== prevProps.options.get('countries')) {
            this.handleShowPassport(userProfile.nationality);
        }
    }

    componentWillUnmount() {
        clickTaleEnd();
        stopPolling();
    }

    onHandleValidateFields() {
        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: 'continuar',
            event_name: 'button_click',
            action: 'click',
            format: 'button',
            component: 'form',
            element: 'continue',
        });

        const { userProfile, formActions, scorings } = this.props;
        const { recordId, investmentType, docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        let requiredFlag = true;

        this.props.focusActions.triggerValidations(true);

        let fieldsWithError = '';
        let j = 0;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const ML2 = scorings ? scorings.getIn(['ml2', 'scoringStatus']) === 'approved' : false;
        if (!disabled) {
            let requiredFields = this.formValidations.primaries;

            if (
                mustIncludeJoinDecisionLikeRequiredField() &&
                !userProfile.isJointHolder &&
                userProfile.investmentType === TRADITIONAL
            ) {
                requiredFields = requiredFields.concat(['jointHolderDecision']);
            }

            if (
                userProfile.country === COUNTRY_CODE_ES &&
                userProfile.documentType !== getMainDocumentTypeByCountry() &&
                this.state.showPassport
            ) {
                requiredFields = requiredFields.concat(['passport']);
            }
            if (userProfile.birthCountry === COUNTRY_CODE_ES) {
                requiredFields = [...requiredFields, 'birthProvince'];
            }

            requiredFields = requiredFields.concat(this.formValidations.firstAddress);

            if (typeof userProfile.jointHolder !== 'undefined' && userProfile.jointHolder.length > 0) {
                userProfile.jointHolder.forEach(function (jointHolder) {
                    requiredFields = requiredFields.concat([
                        `jointHolder_name_${jointHolder}`,
                        `jointHolder_lastName_${jointHolder}`,
                        `jointHolder_secondLastName_${jointHolder}`,
                        `jointHolder_email_${jointHolder}`,
                    ]);
                });
            }

            if (userProfile.creditCardOffer_accepted && ML2) {
                requiredFields = requiredFields.concat(['paymentMethodType']);

                switch (userProfile.paymentMethodType) {
                    case FIXED_PAYMENT_METHOD_VALUE:
                        requiredFields = requiredFields.concat(['fixedPaymentMethodValue']);
                        break;
                    case VARIABLE_PAYMENT_METHOD_VALUE:
                        requiredFields = requiredFields.concat(['variablePaymentMethodValue']);
                        break;
                    default:
                        break;
                }
            }

            requiredFields.forEach(function (requiredField) {
                const field = userProfile[requiredField];
                if (typeof field === 'undefined' || field === '') {
                    if (j === 0) {
                        fieldsWithError += requiredField;
                    } else {
                        fieldsWithError += `|${requiredField}`;
                    }
                    j++;
                    formActions.setValidity(`userProfile.${requiredField}`, { required: false });
                    requiredFlag = false;
                }
            });
        }

        if (!requiredFlag) {
            recordError(`[${fieldsWithError}]:Campos requeridos para continuar.`, investmentType ? investmentType : '');
            recordEvent(
                PATH_CONTACT,
                PAGE_PRODUCT,
                'completa tus datos generales',
                'completa tus datos generales incorrecto',
                recordId,
                '',
                '',
                investmentType ? investmentType : '',
                docNumberEncrypted
            );
        } else {
            formActions.setValidity('userProfile', { valid: true });
        }

        return requiredFlag;
    }

    handleCancel = () => {
        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: 'salir',
        });

        this.props.modalCancelActions.showModalCancel();
    };

    getCountries = () => {
        const {
            options,
            userProfile: { documentType },
        } = this.props;
        const listCountries = options.get('countries').toJSON();
        const mainDocumentType = getMainDocumentTypeByCountry();
        const isRegisteringWithMainDocumentType =
            documentType === mainDocumentType || documentType === getAliasesDocumentType(mainDocumentType);

        const birthCountries = this.getBirthCountries({ listCountries, isRegisteringWithMainDocumentType });
        const nationalityCountries = this.getNationalityCountries({ listCountries, isRegisteringWithMainDocumentType });

        return {
            birthCountries,
            nationalityCountries,
        };
    };

    getBirthCountries({ listCountries, isRegisteringWithMainDocumentType }) {
        const getCountriesAndSortByOriginCountry = (acc, country) => {
            if (__ORIGIN_COUNTRY__ === country.value && isRegisteringWithMainDocumentType) {
                return [country, ...acc];
            }

            return [...acc, country];
        };

        return listCountries.reduce(getCountriesAndSortByOriginCountry, []);
    }

    getNationalityCountries = ({ listCountries, isRegisteringWithMainDocumentType }) => {
        return isCountrySpain()
            ? listCountries.filter(country => isRegisteringWithMainDocumentType || __ORIGIN_COUNTRY__ !== country.value)
            : listCountries;
    };

    getProvinces() {
        const provinces = [];
        let province = {};
        this.props.options.get('cities').forEach(value => {
            if (value) {
                province = value.toObject();
            }
            provinces.push(province);
        });

        return provinces;
    }

    handleToggleAddress() {
        const { userProfile, formActions } = this.props;
        if (typeof userProfile.addPostalAddress === 'undefined') {
            formActions.change('userProfile.addPostalAddress', false);
        }
        formActions.change('userProfile.addPostalAddress', !userProfile.addPostalAddress);
    }

    handleAddressUpdate(field, value) {
        //Aqui deberian ir las validaciones globales
        //Necesitamos verificar la validez del codigo postal con cada update...
        const {
            userProfile,
            formActions: { change, setValidity },
        } = this.props;
        if ((field === 'province' || field === 'postalCode') && userProfile.postalCode && userProfile.province) {
            if (mustValidatePostalCode()) {
                setValidity('userProfile.postalCode', { zip: getValidationPostalCodeByCountry(userProfile) });
            } else {
                setValidity('userProfile.postalCode', { zip: true });
            }
        }

        if (field === 'nameOfRoad' && userProfile.nameOfRoad) {
            const existe = userProfile.address && userProfile.address.includes(userProfile.nameOfRoad);
            if (!existe) {
                change('userProfile.address', '');
            }

            if (userProfile.nameOfRoad.includes('ª'))
                change('userProfile.nameOfRoad', userProfile.nameOfRoad.replace(/ª/g, 'a'));
            if (userProfile.nameOfRoad.includes('º'))
                change('userProfile.nameOfRoad', userProfile.nameOfRoad.replace(/º/g, ''));
        }

        if (field === 'addressNumber' && userProfile.addressNumber) {
            const existe = userProfile.address && userProfile.address.includes(userProfile.addressNumber);
            if (!existe) {
                change('userProfile.address', '');
            }

            if (userProfile.addressNumber.includes('-') || userProfile.addressNumber.includes(','))
                change('userProfile.addressNumber', userProfile.addressNumber.replace(/,|-/g, ' '));
        }

        if (field === 'typeOfRoad' && userProfile.typeOfRoad) {
            const existe = userProfile.address && userProfile.address.includes(userProfile.typeOfRoad);
            if (!existe) {
                change('userProfile.address', '');
            }
        }

        if (field === 'additionalInfo' && userProfile.additionalInfo) {
            if (userProfile.additionalInfo.includes('ª'))
                change('userProfile.additionalInfo', userProfile.additionalInfo.replace(/ª/g, 'a'));
            if (userProfile.additionalInfo.includes('º'))
                change('userProfile.additionalInfo', userProfile.additionalInfo.replace(/º/g, ''));
            if (userProfile.additionalInfo.includes(','))
                change('userProfile.additionalInfo', userProfile.additionalInfo.replace(/,/g, '.'));
        }

        if (!userProfile.country) {
            change('userProfile.country', getReferenceCodeByCountry().toUpperCase());
            this.bufferedSaveAddressInformation('country', getReferenceCodeByCountry().toUpperCase());
        }

        //...pero almacenar los cambios en el buffer
        this.bufferedSaveAddressInformation(field, value);

        userProfile.typeOfRoad &&
            userProfile.nameOfRoad &&
            userProfile.addressNumber &&
            userProfile.postalCode &&
            userProfile.country &&
            !isMobile() &&
            this.throttledGeoAddressScroll();
    }

    throttledGeoAddressScroll(idField = 'typeOfRoad') {
        const addressAutocompleteElement = document.getElementById(idField);
        addressAutocompleteElement && scroll.transition(addressAutocompleteElement, 'percentage', 0.935);
    }

    bufferedSaveAddressInformation(...args) {
        // Esta funcion recibe llamadas durante un segundo a partir del primer call y su entrada es un array de arrays [field, value],
        //  el array de arrays representa el buffer de llamadas acumuladas durante el tiempo de duracion del buffer. Esto es para reducir
        //  multiples llamadas consecutivas a un solo api call.
        const { userProfileForm } = this.props;

        const isValid = args.every(([field]) => userProfileForm[field] && userProfileForm[field].valid);

        //Recorrer el buffer y almacenar el maximo numero de fields validos
        const stuff = args.reduce((acc, [field, value]) => {
            if (field !== 'address' && userProfileForm[field] && userProfileForm[field].valid) {
                acc[field] = value;
            }

            return acc;
        }, {});

        //Verificar si hay algo que salvar
        if (Object.keys(stuff).length > 0) {
            this.handleSave('homeAddress', stuff);
        }

        this.handleNextStep(isValid);
    }

    redirectErrors = error => {
        const errorType = error.body.errors;
        const { formActions } = this.props;
        if (errorType[ERROR_TYPE_POSTALCODE_NOT_MATCH_PROVINCE] || errorType[ERROR_TYPE_POSTALCODE_NOT_VALID]) {
            formActions.setValidity('userProfile.postalCode', { zip: false });
        }
        if (errorType[ERROR_TYPE_CLIENT_ACCOUNT_NOT_IN_HOLDING] || errorType[ERROR_TYPE_CLIENT_IS_BLOCKED]) {
            history.push(`${BASE_PATH}/errors`);
        }
    };

    handleSave(name, value) {
        const { userProfile } = this.props;
        let data = {};
        const accessToken = userProfile.accessToken;

        if (name === 'homeAddress' && typeof value.addressNumber !== 'undefined' && value.addressNumber === '') {
            value.addressNumber = null;
        }
        if (name) {
            data[name] = value;
        } else {
            data = value;
        }

        const showLoader = false;
        this.props.actions.savePersonalInformation(data, accessToken, showLoader, (saved, errors) => {
            if (!saved) {
                this.redirectErrors(errors);
            }
        });
    }

    handleNextStep(valid) {
        const { userProfileForm } = this.props;
        const currentIndex = this.props.immStepsState.get('currentStep');
        const steps = this.props.immStepsState.get('steps');
        const currentStep = steps.get(currentIndex);

        if (currentStep.get('finished')) {
            if (valid && userProfileForm.$form.valid) {
                this.props.actions.enableFinishedAndNextStep();
            } else {
                this.props.actions.disableFollowingStep({
                    index: currentIndex,
                });
            }
        }
    }

    createClient() {
        const { userProfile, createActions, consentsActions, preLoaderActions } = this.props;
        const accessToken = userProfile.accessToken;
        const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        const finishAction = () => {
            this.gotoNextStep();
            preLoaderActions.hidePreLoader();
        };
        const onCreateClient = userId => {
            const { promoCode, investmentType, product, recordId } = userProfile;
            const userAlreadySaved = Storage.cookies.get('roboAnalitycs', true);
            if (!userAlreadySaved) {
                recordCreateNewClient(
                    recordId,
                    userId,
                    product,
                    promoCode ? promoCode : '',
                    '',
                    '',
                    investmentType ? investmentType : 'robo',
                    jointHolderInfo
                );
                Storage.cookies.set('roboAnalitycs', true);
            }
        };
        const onError = () => {
            preLoaderActions.hidePreLoader();
        };
        createClientWithConsent({ createActions, consentsActions }, accessToken, onCreateClient, finishAction, onError);
    }

    handleVerify() {
        const { userProfile, actions, ibanActions, preLoaderActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;

        actions.clientVerify(accessToken, (verified, error) => {
            if (verified) {
                ibanActions.toggleShowIban(false);
                if (
                    mustIncludeJoinDecision() ||
                    userProfile.jointHolderDecision === 'false' ||
                    userProfile.investmentType === ROBO ||
                    userProfile.investmentType === GBI ||
                    userProfile.investmentType === CREDIT_CARD
                ) {
                    actions.clientCardConfigVerify(accessToken, (verifiedOk, error) => {
                        if (verifiedOk) {
                            if (userProfile.investmentType === ROBO || userProfile.investmentType === GBI) {
                                this.createClient();
                            } else {
                                this.gotoNextStep();
                                preLoaderActions.hidePreLoader();
                            }
                            recordEvent(
                                PATH_CONTACT,
                                PAGE_PRODUCT,
                                'completa tus datos generales',
                                'completa tus datos generales correcto',
                                userProfile.recordId,
                                '',
                                '',
                                userProfile.investmentType,
                                docNumberEncrypted
                            );
                            recordEventStepSuccess(
                                userProfile.investmentType,
                                '/onboarding/completa-tus-datos-generales',
                                'completa tus datos personales',
                                {
                                    event_name: 'event_success',
                                    action: 'success',
                                    format: 'steps',
                                    component: 'funnel',
                                    element: 'general data',
                                }
                            );
                        } else {
                            preLoaderActions.hidePreLoader();
                            if (error.body.errors['6002']) {
                                history.push(`${BASE_PATH}/errors`);
                            }
                        }
                    });
                } else {
                    preLoaderActions.hidePreLoader();
                }
            } else {
                preLoaderActions.hidePreLoader();
                errorTag(error.body, PATH_CONTACT, ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE, error.statusCode);
                if (error.body.errors['0243'] || error.body.errors['0242']) {
                    this.props.formActions.setValidity('userProfile.postalCode', { zip: false });
                }
                if (error.body.errors['6002']) {
                    history.push(`${BASE_PATH}/errors`);
                }
            }
        });
    }

    handleShowPassport(value) {
        const { userProfile, flags, options } = this.props;
        const ueCountries = getEuropeanUnionContries(options.get('countries'), userProfile.documentType);
        const docTypeRegex = new RegExp(`${COUNTRY_DOCUMENT_TYPE_NIE}|${COUNTRY_DOCUMENT_TYPE_NIE_LABEL}`);
        const isNewRegisterActive = flags.get(ONBOARDING_FLAG_WEB_NEW_REGISTER);
        if (
            !isNewRegisterActive &&
            showPassportProfile1() &&
            docTypeRegex.test(userProfile.documentType) &&
            ueCountries.indexOf(value) !== -1
        ) {
            this.setState({ showPassport: true });
        } else {
            this.setState({ showPassport: false });
        }
    }

    buildPassport() {
        const { userProfile } = this.props;
        const handleSave = this.handleSave;
        const handleNextStep = this.handleNextStep;
        const disabled = this.props.immStepsState.get('readOnlyForms');

        return (
            <div className="row">
                <div className="md-form-group col-lg-5">
                    <InputPassport
                        label={formatText('field-passport')}
                        onValidation={isValid => {
                            handleNextStep(isValid);
                            isValid && handleSave('passport', userProfile.passport.replace(/\s+/g, ''));
                        }}
                        isRequired
                        disabled={disabled}
                        {...this.props}
                    />
                </div>
            </div>
        );
    }

    getHomeAddress() {
        const { userProfile } = this.props;
        const homeAddress = {};

        if (userProfile.typeOfRoad) {
            homeAddress['typeOfRoad'] = userProfile.typeOfRoad;
        }
        if (userProfile.nameOfRoad) {
            homeAddress['nameOfRoad'] = userProfile.nameOfRoad;
        }
        if (userProfile.addressNumber) {
            homeAddress['addressNumber'] = userProfile.addressNumber;
        }
        if (userProfile.addressFloorNumber) {
            homeAddress['addressFloorNumber'] = userProfile.addressFloorNumber;
        }
        if (userProfile.department) {
            homeAddress['department'] = userProfile.department;
        }
        if (userProfile.postalCode) {
            homeAddress['postalCode'] = userProfile.postalCode;
        }
        if (userProfile.town) {
            homeAddress['town'] = userProfile.town;
        }
        if (userProfile.province) {
            homeAddress['province'] = userProfile.province;
        }
        if (userProfile.country) {
            homeAddress['country'] = userProfile.country;
        }

        return homeAddress;
    }

    showJointHolderDecision() {
        const {
            userProfile: { isJointHolder, investmentType },
        } = this.props;
        const handleSave = this.handleSave;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

        return (
            <ConditionalToggling condition={!isJointHolder && userInvestmentType[TRADITIONAL]}>
                <div className="md-form-group form__input">
                    <JointHolderDecisionDispatcher handleSave={handleSave} />
                </div>
            </ConditionalToggling>
        );
    }

    getAllData() {
        const { userProfile } = this.props;
        const homeAddress = this.getHomeAddress();
        const data = {};
        homeAddress['addressNumber'] = userProfile.addressNumber;
        data['cellPhone'] = userProfile.cellPhone.replace(/\s/g, '');
        data['homeAddress'] = homeAddress;
        data['gender'] = userProfile.gender;
        data['cellphonePrefix'] = userProfile.cellphonePrefix || getReferencePrefixByCountry();
        if (userProfile.shouldShowNationalityField) {
            data['nationality'] = userProfile.nationality;
        }
        data['birthCountry'] = userProfile.birthCountry;
        data['birthPopulation'] = userProfile.birthPopulation;
        data['birthProvince'] = userProfile.birthProvince;

        if (!userProfile.isJointHolder) {
            data['jointHolderDecision'] = userProfile.jointHolderDecision || false;
        } else {
            data['jointHolderDecision'] = null;
        }
        if (typeof userProfile.passport !== 'undefined') {
            data['passport'] = userProfile.passport.replace(/\s+/g, '');
        }

        return data;
    }

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        actions.finalizeStep({
            index: currentIndex,
            finished: true,
        });
        actions.enableFinishedAndNextStep();
        actions.changeCurrentStep({
            index: currentIndex + 1,
        });
    }

    checkboxEvent() {
        const { userProfile, scorings } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const ml2 = scorings.getIn(['ml2', 'scoringStatus']) === 'approved';

        if (ml2) {
            if (userProfile.creditCardOffer_accepted) {
                recordEvent(
                    PATH_CONTACT,
                    PAGE_PRODUCT,
                    'tarjeta de credito checkbox',
                    'tarjeta de credito checkbox checkeado',
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
            } else {
                recordEvent(
                    PATH_CONTACT,
                    PAGE_PRODUCT,
                    'tarjeta de credito checkbox',
                    'tarjeta de credito checkbox no checkeado',
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
            }
        }
    }

    handleEnableSubmit() {
        const { userProfile, userProfileForm } = this.props;
        const fieldsToValidate = [...this.formValidations.primaries, ...this.formValidations.firstAddress];
        const askForClicked = [];
        let clicked = true;
        let value;
        if (
            userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI_LABEL ||
            userProfile.documentType === COUNTRY_DOCUMENT_TYPE_NIE_LABEL ||
            userProfile.documentType === COUNTRY_DOCUMENT_TYPE_DNI ||
            userProfile.documentType === COUNTRY_DOCUMENT_TYPE_NIE
        ) {
            if (userProfile.investmentType === TRADITIONAL && !userProfile.universiaName) {
                fieldsToValidate.push('jointHolderDecision');
            }
        }
        if (userProfile.documentType === COUNTRY_DOCUMENT_TYPE_NIE_LABEL && this.state.showPassport) {
            value =
                typeof userProfile.passport !== 'undefined' &&
                userProfile.passport.value !== '' &&
                userProfile.passport.value !== null &&
                userProfile.passport.valid;
            askForClicked.push(value);
        }
        if (userProfile.birthCountry === COUNTRY_CODE_ES) {
            fieldsToValidate.push('birthProvince');
        }

        fieldsToValidate.forEach(prop => {
            value =
                typeof userProfileForm[prop] !== 'undefined' &&
                !!userProfileForm[prop].value &&
                userProfileForm[prop].valid;
            askForClicked.push(value);
        });

        clicked = askForClicked.indexOf(false) !== -1;

        this.setState({ isClicked: clicked });
    }

    handleSubmit() {
        const { userProfileForm, userProfile, actions, formActions, immStepsState, options } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;
        const disabled = immStepsState.get('readOnlyForms');
        const isVerified = this.state.isVerified;
        const data = this.getAllData();
        const currentIndex = immStepsState.get('currentStep');
        const isDeposit =
            userProfile.investmentType === TRADITIONAL && userProfile.onboardingType === ONB_BANK_DEPOSIT_OPEN;

        this.setState({ isClicked: true });

        if (!disabled && userProfileForm.$form.valid && !isVerified) {
            if ((userProfile.investmentType === ROBO || userProfile.investmentType === GBI) && userProfile.userId) {
                actions.changeCurrentStep({
                    index: currentIndex + 1,
                });
            } else {
                if (mustValidatePostalCode() && !getValidationPostalCodeByCountry(userProfile)) {
                    return formActions.setValidity('userProfile.postalCode', { zip: false });
                }
                let saveError = false;
                const showLoader = true;

                const formattedAddress = addressHelper.generateFormattedAddress(
                    userProfile.nameOfRoad,
                    userProfile.addressNumber,
                    userProfile.postalCode,
                    userProfile.town,
                    userProfile.province,
                    userProfile.country,
                    options.get('cities'),
                    options.get('countries')
                );

                this.props.formActions.change('userProfile.address', formattedAddress);
                actions.savePersonalInformation(data, accessToken, showLoader, (saved, error) => {
                    if (saved) {
                        this.handleVerify();
                    } else {
                        errorTag(error.body, PATH_CONTACT, ERROR_AL_AGREGAR_INFORMACION_ADICIONAL, error.statusCode);
                        this.redirectErrors(error);
                        saveError = true;
                        this.setState({ isClicked: false });
                    }
                });
                if (userProfile.jointHolderDecision === 'true') {
                    recordEvent(
                        PATH_CONTACT,
                        PAGE_PRODUCT,
                        'completa tus datos generales',
                        'completa tus datos generales correcto',
                        userProfile.recordId,
                        '',
                        '',
                        userProfile.investmentType,
                        docNumberEncrypted
                    );
                    recordEventStepSuccess(
                        userProfile.investmentType,
                        '/onboarding/completa-tus-datos-generales',
                        'completa tus datos personales'
                    );
                    if (isDeposit) {
                        formActions.change('userProfile.showJointHolderDepositAdvise', true);
                        recordEventCustomOnly({
                            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
                            accionEvento: 'depositos/aviso-titulares/modal',
                            etiquetaEvento: 'vista',
                        });
                    }
                    formActions.change('userProfile.showJointHolder', true);
                    formActions.change('userProfile.isJointHolderAccount', true);
                    this.setState({ isClicked: false });
                    window.scrollTo(0, 0);
                } else if (!saveError) {
                    const finishedStep = immStepsState.get('steps').get(0).get('finished');
                    if (finishedStep) {
                        this.setState({ isVerified: true });
                    }
                }
            }
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }

        this.checkboxEvent();
    }

    closeDepositWarning() {
        const { formActions } = this.props;
        recordEventCustomOnly({
            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
            accionEvento: 'depositos/aviso-titulares/modal',
            etiquetaEvento: 'entendido',
        });
        formActions.change('userProfile.showJointHolderDepositAdvise', false);
    }

    getOpenCredit() {
        const { cms, scorings } = this.props;
        const setLimit = scorings ? scorings.getIn(['ml2', 'cardLimit']) : 0;
        let format = null;
        let text = formatText('CMS-additionalTCText');
        let tooltip = <FormattedText value="CMS-additionalTCTooltip" />;

        if (cms.getIn(['cmsAdditional', 'text']) && cms.getIn(['cmsAdditional', 'tooltip'])) {
            format = cms.getIn(['cmsAdditional', 'text']).replace(/p>/g, 'span>');
            text = <HTMLSafeInjector message={format} inline={true} />;
            tooltip = <HTMLSafeInjector message={cms.getIn(['cmsAdditional', 'tooltip'])} />;
        }

        return <OpenCreditSale limit={setLimit} CMSText={text} CMSTooltip={tooltip} tagPath={PATH_CONTACT} />;
    }

    buildForm() {
        const { userProfileForm, scorings } = this.props;
        const { isClicked } = this.state;

        const isValidForm = userProfileForm.$form.valid;
        const isDisabled = !isValidForm || isClicked;
        const handleSave = this.handleSave;
        const handleNextStep = this.handleNextStep;
        const showPassport = this.state.showPassport;
        const handleShowPassport = this.handleShowPassport;
        const passport = showPassport ? this.buildPassport() : '';
        const showJointHolderDecision = this.showJointHolderDecision();
        const handleAddressUpdate = this.handleAddressUpdate;
        const ML2 = scorings ? scorings.getIn(['ml2', 'scoringStatus']) === 'approved' : false;
        const opencredit = ML2 && this.state.checkbox ? this.getOpenCredit() : null;
        const { birthCountries, nationalityCountries } = this.getCountries();

        return (
            <Form
                classname="profile-step-1-form"
                model="userProfile"
                onSubmit={this.handleSubmit}
                onChange={this.handleEnableSubmit}
                aria-label="Contact information"
            >
                <Headline icon="cliente" className="prospects-gutter">
                    <h2>{formatText('stepsTitles-CompleteGeneralData')}</h2>
                </Headline>
                <ProfileStep1Form
                    handleSave={handleSave}
                    handleNextStep={handleNextStep}
                    handleShowPassport={handleShowPassport}
                    showPassport={showPassport}
                    passport={passport}
                    showJointHolderDecision={showJointHolderDecision}
                    birthCountries={birthCountries}
                    nationalityCountries={nationalityCountries}
                    handleAddressUpdate={handleAddressUpdate}
                    showOpenCredit={opencredit}
                    getProvinces={this.getProvinces}
                    showAdditionalDataAdvise={!isDisabled}
                />
                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueType={'submit'}
                            buttonPrevHidden
                            buttonContinueClass={`form__button roadmap-navigation__button-continue form__button-primary ${
                                isDisabled ? 'disable-styles' : ''
                            }`}
                            buttonCancelAction={this.handleCancel}
                            buttonContinueAction={this.onHandleValidateFields}
                        />
                    </div>
                </div>
            </Form>
        );
    }

    render() {
        const { userProfile } = this.props;
        let block;

        if (userProfile.showJointHolder) {
            block = (
                <>
                    <JointHolder />
                    <JointHolderAdviseModal
                        isOpen={userProfile.showJointHolderDepositAdvise}
                        onClickMainAction={this.closeDepositWarning}
                    />
                </>
            );
        } else if (userProfile.showOTP) {
            block = <OtpView />;
        } else {
            block = this.buildForm();
        }

        return <div className="basic-layering">{block}</div>;
    }
}

module.exports.constructor = ProfileStep1;
module.exports.ProfileStep1 = connect(
    state => ({
        userProfile: state.userProfile,
        extraData: state.extraData,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        focus: state.focus,
        products: state.products,
        cms: state.cms,
        scorings: state.scorings,
        initialStep: state.initialStep,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        ibanActions: bindActionCreators(ibanActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        cmsActions: bindActionCreators(cmsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
    })
)(withFeatureToggling(ProfileStep1));
